export default __webpack_public_path__ + "static/media/loader.f4c41ec1.svg";